/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SapProfileActionSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SapProfileActionSettingsQuery = { sapConfig: { __typename: 'SapS4HanaConfig', hideResetPassword?: boolean | null, hideDeleteProfile?: boolean | null, defaultJobTitle?: string | null } };


export const SapProfileActionSettingsDocument = gql`
    query SapProfileActionSettings {
  sapConfig {
    hideResetPassword
    hideDeleteProfile
    defaultJobTitle
  }
}
    `;

/**
 * __useSapProfileActionSettingsQuery__
 *
 * To run a query within a React component, call `useSapProfileActionSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSapProfileActionSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSapProfileActionSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSapProfileActionSettingsQuery(baseOptions?: Apollo.QueryHookOptions<SapProfileActionSettingsQuery, SapProfileActionSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SapProfileActionSettingsQuery, SapProfileActionSettingsQueryVariables>(SapProfileActionSettingsDocument, options);
      }
export function useSapProfileActionSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SapProfileActionSettingsQuery, SapProfileActionSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SapProfileActionSettingsQuery, SapProfileActionSettingsQueryVariables>(SapProfileActionSettingsDocument, options);
        }
export function useSapProfileActionSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SapProfileActionSettingsQuery, SapProfileActionSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SapProfileActionSettingsQuery, SapProfileActionSettingsQueryVariables>(SapProfileActionSettingsDocument, options);
        }
export type SapProfileActionSettingsQueryHookResult = ReturnType<typeof useSapProfileActionSettingsQuery>;
export type SapProfileActionSettingsLazyQueryHookResult = ReturnType<typeof useSapProfileActionSettingsLazyQuery>;
export type SapProfileActionSettingsSuspenseQueryHookResult = ReturnType<typeof useSapProfileActionSettingsSuspenseQuery>;
export type SapProfileActionSettingsQueryResult = Apollo.QueryResult<SapProfileActionSettingsQuery, SapProfileActionSettingsQueryVariables>;